import { render, staticRenderFns } from "./QnAModerationCheckBox.vue?vue&type=template&id=a3b31518&scoped=true&"
import script from "./QnAModerationCheckBox.vue?vue&type=script&lang=js&"
export * from "./QnAModerationCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./QnAModerationCheckBox.vue?vue&type=style&index=0&id=a3b31518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b31518",
  null
  
)

export default component.exports